import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxEntity } from 'site-modules/lease-deals/components/filters/entities/options-entity';
import { CheckboxList } from 'site-modules/lease-deals/components/filters/ui/primitives/checkbox-list/checkbox-list';
import { CheckboxItem } from 'site-modules/lease-deals/components/filters/ui/primitives/checkbox-item/checkbox-item';

export const StandardCheckboxControl = ({ options, selectedValues = [], onChange, classNames = null }) => {
  return (
    <CheckboxList
      options={options}
      selectedValues={selectedValues}
      onChange={onChange}
      classNames={classNames}
      checkboxComponent={CheckboxItem}
    />
  );
};

StandardCheckboxControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: CheckboxEntity.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  classNames: PropTypes.string,
};
